(function(){
  var yen=function(n){return '¥'+Math.round(n).toLocaleString('ja-JP');};
  function init(root){
    var form=root.querySelector('[data-form]'); if(!form) return;
    var btn=root.querySelector('[data-atc]');
    var totalEl=root.querySelector('[data-total]');
    var shipEl=root.querySelector('[data-ship]');
    var errEl=root.querySelector('[data-error]');
    var threshold=parseInt(root.getAttribute('data-threshold'),10)||0;
    var addUrl=root.getAttribute('data-cart-add-url')||'/cart/add';
    var cartUrl=root.getAttribute('data-cart-url')||'/cart';

    function calc(){
      var main=form.querySelector('input[name="id"]:checked');
      var total=main?parseInt(main.getAttribute('data-final'),10):0;
      form.querySelectorAll('[data-addon]:checked').forEach(function(c){ total+=parseInt(c.getAttribute('data-final'),10); });
      if(totalEl) totalEl.textContent=yen(total);
      if(shipEl && threshold>0){
        shipEl.textContent = total>=threshold ? '送料無料の対象です' : 'あと'+yen(threshold-total)+'のご注文で送料無料';
        shipEl.classList.toggle('is-free', total>=threshold);
      }
      form.querySelectorAll('.dv-plan').forEach(function(l){ l.classList.toggle('is-selected', l.querySelector('input').checked); });
      form.querySelectorAll('.dv-addon').forEach(function(l){ l.classList.toggle('is-selected', l.querySelector('input').checked); });
    }
    form.addEventListener('change',function(e){
      var t=e.target;
      if(t && t.matches && t.matches('[data-addon]') && t.checked){
        form.querySelectorAll('[data-addon]').forEach(function(o){
          if(o!==t && o.checked && (t.hasAttribute('data-exclusive')||o.hasAttribute('data-exclusive'))) o.checked=false;
        });
      }
      calc();
    });
    calc();

    form.addEventListener('submit',function(e){
      e.preventDefault();
      var main=form.querySelector('input[name="id"]:checked'); if(!main||btn.disabled) return;
      var items=[{id:parseInt(main.value,10),quantity:1}];
      form.querySelectorAll('[data-addon]:checked').forEach(function(c){ items.push({id:parseInt(c.value,10),quantity:1}); });
      btn.disabled=true; errEl.hidden=true;
      fetch(addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description||j.message||''); return j; }); })
        .then(function(){ window.location.href=cartUrl; })
        .catch(function(err){ errEl.textContent='カートに追加できませんでした。'+(err.message||''); errEl.hidden=false; btn.disabled=false; });
    });

    var g=root.querySelector('[data-gallery]'), tr=g&&g.querySelector('.dv__track'), ct=g&&g.querySelector('[data-counter]');
    if(tr&&ct){ tr.addEventListener('scroll',function(){ var n=Math.round(tr.scrollLeft/tr.clientWidth)+1; ct.textContent=n+' / '+tr.children.length; },{passive:true}); }
  }
  document.querySelectorAll('[data-dv]').forEach(init);
})();